import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-38cffc80")

_pushScopeId("data-v-38cffc80")
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-row items-center font-semibold text-20px mr-4 text-black-lp-200 title-layout" }
const _hoisted_3 = { class: "mr-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "w-5 mr-3",
  style: {"flex-shrink":"0"}
}, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "w-full absolute bottom-0 left-0 px-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_FloatingAction = _resolveComponent("FloatingAction")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          fullPage: _ctx.fullPage,
          onBack: _ctx.onBack
        }, null, 8, ["fullPage", "onBack"]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", {
            class: 
        `flex flex-row justify-between items-center ${_ctx.headerPadding} ${
          _ctx.noSpaceHeader || _ctx.isTab ? '' : 'border-b'
        } border-gray-lp-400  ${_ctx.headerNewLayout ? 'px-8' : ''}`
      
          }, [
            _createVNode("div", {
              class: `flex flex-col ${_ctx.noSpaceHeader ? '' : 'py-4'} w-3/5`
            }, [
              _createVNode("div", _hoisted_1, [
                (_ctx.displayBack)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _imports_0,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args))),
                      "data-testid": _ctx.backButtonTestId,
                      class: "w-5 mr-3 cursor-pointer",
                      alt: "back"
                    }, null, 8, ["data-testid"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_2, [
                  _createVNode("p", _hoisted_3, _toDisplayString(_ctx.error ? "" : _ctx.firstCapitalizeString(_ctx.title.toString())), 1),
                  _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                ])
              ]),
              _createVNode("div", {
                class: ["flex text-gray-lp-600 xxl:text-14px text-12px", !!_ctx.$slots.description ? 'mt-3' : '']
              }, [
                _hoisted_4,
                _renderSlot(_ctx.$slots, "description", {}, undefined, true)
              ], 2)
            ], 2),
            _renderSlot(_ctx.$slots, "top-right", {}, undefined, true)
          ], 2),
          (_ctx.isTab)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "custom-tab", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 1,
                errorType: _ctx.errorType,
                onTryAgain: _ctx.onTryAgain
              }, null, 8, ["errorType", "onTryAgain"]))
            : _withDirectives((_openBlock(), _createBlock("div", {
                key: 2,
                class: `detail-parent flex flex-row h-full ${_ctx.usePaddingVertical} relative overflow-auto`
              }, [
                _createVNode("div", {
                  id: "detailLayoutData",
                  class: ["text-12px xxl:text-14px space-y-6", `${_ctx.customClass} ${_ctx.fullPage ? 'w-full' : 'w-2/4 sm:w-3/4'}`],
                  ref: "detailLayoutData",
                  onScrollPassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
                }, [
                  _renderSlot(_ctx.$slots, "data", {}, undefined, true)
                ], 34),
                _createVNode("div", {
                  class: 
          `${_ctx.fullPage ? '' : 'w-2/4 sm:w-1/4 pl-4'} text-12px xxl:text-14px ${
            _ctx.verticalSeparator ? 'border-l' : ''
          } ${_ctx.scrollSidebar &&
            'overflow-y-auto h-full pb-20'} border-gray-lp-400 space-y-6`
        
                }, [
                  _renderSlot(_ctx.$slots, "sub-data", {}, () => [
                    (_ctx.subData.status)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 0,
                          label: "Status"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ChipsV2, {
                              class: "my-2",
                              label: _ctx.subData.status
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.subData.createdAt && _ctx.subData.createdBy)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 1,
                          label: "Tanggal Dibuat",
                          value: _ctx.formatDate(_ctx.subData.createdAt),
                          caption: _ctx.subData.createdBy
                        }, null, 8, ["value", "caption"]))
                      : _createCommentVNode("", true),
                    (_ctx.subData.updatedAt && _ctx.subData.updatedBy)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 2,
                          label: "Tanggal Diubah",
                          value: _ctx.formatDate(_ctx.subData.updatedAt),
                          caption: _ctx.subData.updatedBy
                        }, null, 8, ["value", "caption"]))
                      : _createCommentVNode("", true),
                    (_ctx.subData.isEditable)
                      ? (_openBlock(), _createBlock(_component_LpButton, {
                          key: 3,
                          title: _ctx.$t('edit'),
                          onClick: _ctx.subData.goEdit,
                          "custom-class": "w-44",
                          textColor: "red-lp-100",
                          outline: ""
                        }, null, 8, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ], {}, true)
                ], 2)
              ], 2)), [
                [_vShow, _ctx.showContent]
              ]),
          _createVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "floating-footer", {}, undefined, true)
          ])
        ], 64)),
    (_ctx.isFloatingAction)
      ? (_openBlock(), _createBlock(_component_FloatingAction, {
          key: 2,
          targetRef: _ctx.dataRef,
          scrollPercent: _ctx.scrollPercent
        }, null, 8, ["targetRef", "scrollPercent"]))
      : _createCommentVNode("", true),
    (_ctx.isConfirm)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 3,
          onSubmit: _ctx.onDelete,
          onClose: () => _ctx.onConfirm(false),
          title: "Yakin ingin menghapus aktivitas ini?",
          message: "Pastikan kembali, Anda akan kehilangan data aktivitas ketika Anda hapus aktivitas ini",
          image: "delete-confirm",
          textSuccess: "Hapus",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.leavePageConfirmation)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 4,
          "on-submit": _ctx.onSubmitLeavePage,
          "on-close": _ctx.onCloseLeavePage,
          title: _ctx.$t('Yakin Meninggalkan Halaman?'),
          message: _ctx.$t('Perubahan yang Anda tambahkan akan terhapus'),
          image: "leaving-page-illustration",
          textSuccess: _ctx.$t('Ya'),
          textCancel: _ctx.$t('Tidak'),
          class: "px-8"
        }, null, 8, ["on-submit", "on-close", "title", "message", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true)
  ], 64))
})